import { useRecoilValue } from 'recoil'
import organizationsTableFields from './organizations.table.fields.tsx'
import organizationsAtom from '@/pages/Organizations/organizations.atom.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import Table from '@/shared/Tables/Table'
import useRegularTable from '@/shared/Tables/Table/ctrl/useRegularTable.ts'

interface IProps {
  onClick?: (organization: IOrganization) => void
}

const OrganizationsTable = (props: IProps) => {
  const items = useRecoilValue(organizationsAtom).items

  const tableCtrl = useRegularTable({
    fields: organizationsTableFields,
    tableKey: 'organizations',
    itemKey: 'id',
    items,
  })

  return <Table {...tableCtrl} items={items as any} itemKey="id" onClick={props.onClick} loading={false} />
}

export default OrganizationsTable
